import { Injectable } from "@angular/core";



@Injectable({
    providedIn: 'root'
})

export class UtilityService {
    
    anchorClientId = -1;
    /*

    @Generating anchor client id used for opening and closing inputs in mng-anchors table

    */
    getAnchorClientId(): number {

        return this.anchorClientId--;
    }
}